import { Notification } from "@drone-js/core";
import { memo } from "react";

interface Props {
    message?: string;
}

export const ErrorFieldNotification = memo<Props>(({ message }) => {
    if (!message) return null;

    return (
        <Notification
            intent="error"
            asset={{
                id: "fill.symbol.triangle-exclamation",
            }}
            title={message}
        />
    );
});
